"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GraphTitle = void 0;

var _preact = require("preact");

var _assets = _interopRequireDefault(require("@insided/deprecated-preact-components/assets"));

var _Tooltip = _interopRequireDefault(require("@insided/shared/uikit/Tooltip"));

/* eslint-disable import/prefer-default-export */
var GraphTitle = function GraphTitle(_ref) {
  var customClass = _ref.customClass,
      title = _ref.title,
      tooltipMessage = _ref.tooltipMessage;
  return (0, _preact.h)("div", {
    className: "graph-title ".concat(customClass || '')
  }, title, tooltipMessage && (0, _preact.h)(_Tooltip.default, {
    position: "center",
    trigger: (0, _preact.h)(_assets.default, {
      icon: "question",
      width: 16,
      height: 16,
      customClass: "icon-info"
    }),
    customClasses: "graph-help-tooltip",
    tooltipMessage: tooltipMessage
  }));
};

exports.GraphTitle = GraphTitle;